import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";

/** Shared form for invite set-password and password reset. */
export function PasswordForm({ endpoint, title, blurb, testid }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Passwords don't match.");
    setBusy(true);
    try {
      await api.post(endpoint, { token, password });
      toast.success("Password set — you can sign in now");
      navigate("/admin/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f5f3ed] px-6" data-testid={`${testid}-page`}>
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-[#c19872] rounded-xl p-10">
        <p className="btw-overline mb-3">Behind the Love</p>
        <h1 className="text-3xl font-bold mb-1">{title}</h1>
        <p className="text-sm text-black mb-8 mt-4">{blurb}</p>
        {!token && (
          <p className="text-sm text-[#b35c5c] mb-6" data-testid={`${testid}-no-token`}>
            This link is missing its token — please use the full link from your email.
          </p>
        )}
        <label className="btw-overline block mb-2">New password (min 8 characters)</label>
        <input
          data-testid={`${testid}-password`}
          type="password"
          required
          minLength={8}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="btw-input mb-6"
        />
        <label className="btw-overline block mb-2">Confirm password</label>
        <input
          data-testid={`${testid}-confirm`}
          type="password"
          required
          minLength={8}
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          className="btw-input mb-8"
        />
        <button type="submit" disabled={busy || !token} data-testid={`${testid}-submit`} className="btw-btn w-full">
          {busy ? "Saving…" : "Set password"}
        </button>
        <p className="text-sm text-black mt-8">
          <Link to="/admin/login" className="underline">Back to sign in</Link>
        </p>
      </form>
    </div>
  );
}

export default function AdminResetPassword() {
  return (
    <PasswordForm
      endpoint="/auth/reset-password"
      title="Reset password"
      blurb="Choose a new password for your admin account."
      testid="reset-password"
    />
  );
}
